<template>
  <div class="CorporateCulture">
    <div class="main">
      <p class="title">企业文化</p>
      <ul class="items">
        <li class="item" v-for="culture,index in cultures">
          <img :src="culture.imgUrl" />
          <p class="title">{{culture.title}}</p>
          <p class="remark">{{culture.remark}}</p>
        </li>
      </ul>



      <p class="title">团队文化建设</p>

      <div class="swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img :src="teamImg1"/>
              <p>公司每年组织员工参与团建拓展活动</p>
            </div>
            <div class="swiper-slide">
              <img :src="teamImg2"/>
              <p>公司年会盛大激动人心的现金抽奖活动</p>
            </div>
            <div class="swiper-slide">
              <img :src="teamImg3"/>
              <p>中秋节组织员工体能比赛幸运获奖队伍</p>
            </div>
          </div>
        </div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev swiper_btn"></div>
        <div class="swiper-button-next swiper_btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper/dist/js/swiper.js'
  export default {
    name: 'CorporateCulture',
    data() {
      return {
        cultures: [
          {imgUrl: require("@/assets/imgs/img-aboutus-01.png"),title:"保持自律",remark:"成功的关键不是你执行的多完美而是你坚持的有多久"},
          {imgUrl: require("@/assets/imgs/img-aboutus-02.png"),title:"追求极致",remark:"所有工作都是为了创造完美的产品创造让用户满意的完美产品"},
          {imgUrl: require("@/assets/imgs/img-aboutus-03.png"),title:"超越极限",remark:"不断超越极限只有想不到，没有做不到"},
        ],
        teamImg1: require("@/assets/imgs/team-build-01.png"),
        teamImg2: require("@/assets/imgs/team-build-02.png"),
        teamImg3: require("@/assets/imgs/team-build-03.png")
      }
    },
    mounted() {
      var mySwiper = new Swiper('.CorporateCulture .swiper-container', {
        autoplay: true,
        loop: true,
        speed: 1000,

        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      })
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .CorporateCulture {
    width: 100%;
    padding-bottom: 60px;

    .main {
      width: 1200px;
      margin: 0 auto;
      p {
        margin: 0;
      }
      >.title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-top: 59px;
        margin-bottom: 29px;
      }

      .items {
        margin: 0;
        display: inline-block;
        padding-left: 80px;

        .item {
          width: 280px;
          list-style: none;
          float: left;
          margin-bottom: 50px;
          p{
            text-align: center;
          }

          >img {
            width: 280px;
            height: 200px;
            border-radius: 8px;
          }
          >.title {
            height:30px;
            font-size:24px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin-top: 38px;
          }
          >.remark {
            height:25px;
            line-height:32px;
            font-size:18px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(136,136,136,1);
            margin: 12px 0;
          }
        }
        .item:nth-of-type(2),
        .item:nth-of-type(5) {
          margin: 0 100px;
        }
      }



      .swiper {
        width: 1200px;
        position:relative;

        .swiper-container {
          width: 820px;
          height: 460px;
          box-sizing: border-box;
          margin: 0 190px;

          img {
            width: 100%;
            border-radius: 15px;
          }

          p {
            height: 60px;
            line-height: 60px;
            font-size:18px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(40,40,40,1);
            text-align: center;
          }
        }

        .swiper_btn{
          width: 45px;
          height: 92px;
          background-size: contain;
          outline: none;
          top: 50%;
          transform: translate(0,-50%);
          padding: 5px 15px;
        }
        .swiper-button-prev {
          background: url("../../assets/imgs/arrow-left.png") no-repeat center;
          background-size: 35px 70px;
          &:hover {
            background-position: 20%;
            background-size: 45px 92px;
          }
        }
        .swiper-button-next {
          background: url("../../assets/imgs/arrow-right.png") no-repeat center;
          background-size: 35px 70px;
          &:hover {
            background-position: 80%;
            background-size: 45px 92px;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/About_Us/CorporateCulture.vue